export enum ProjectProductTypes {
  Loan = 0,
  GUARANTEE = 1,
  CT = 2,
  IG = 3,
}
